import { CAPABILITIES } from '../content/copy';
import DemoAsset from '../components/DemoAsset';
import { Link } from '../hooks/useRouter';

export default function Capabilities({ onContact }) {
  return (
    <>
      <section className="bv-page-hero">
        <div className="bv-wrap">
          <p className="bv-eyebrow">Capabilities</p>
          <h1 className="bv-h1">Deploy the stack. Don’t rent a bench.</h1>
          <p className="bv-lead">
            We work where Black Vanilla perception should live in a real operation. These are product and technology deployments — not staff augmentation.
          </p>
        </div>
      </section>

      <section className="bv-section bv-section-tight">
        <div className="bv-wrap bv-cap-list">
          {CAPABILITIES.map((c, i) => (
            <article key={c.id} className="bv-cap-row">
              <div className="bv-cap-copy">
                <span className="bv-loop-step">0{i + 1}</span>
                <h2 className="bv-h2">{c.title}</h2>
                <p className="bv-lead">{c.body}</p>
                <ul className="bv-tags">
                  {c.tags.map((t) => <li key={t}>{t}</li>)}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="bv-section bv-section-surface">
        <div className="bv-wrap bv-split">
          <div>
            <p className="bv-eyebrow">Robotics</p>
            <h2 className="bv-h2">Perception on a moving platform.</h2>
            <p className="bv-lead">
              The same localization, mapping, and scene understanding that feed civil3d are intended for robots that have to move through unstructured space.
            </p>
            <div className="bv-hero-btns">
              <button type="button" className="bv-btn bv-btn-solid" onClick={onContact}>Discuss a deployment</button>
              <Link to="/technology" className="bv-btn bv-btn-ghost">See the stack</Link>
            </div>
          </div>
          <DemoAsset id="robotics-demo" fallback={<RobotPlaceholder />} />
        </div>
      </section>
    </>
  );
}

function RobotPlaceholder() {
  return (
    <div className="bv-placeholder-viz" aria-hidden="true">
      <svg viewBox="0 0 640 400" className="bv-arch-svg">
        <rect x="250" y="160" width="140" height="90" fill="none" stroke="currentColor" strokeWidth="1.4" />
        <circle cx="280" cy="270" r="22" fill="none" stroke="currentColor" />
        <circle cx="360" cy="270" r="22" fill="none" stroke="currentColor" />
        <path d="M320 160 L200 80 M320 160 L440 70 M320 160 L320 40" stroke="currentColor" opacity="0.35" strokeDasharray="4 6" />
        {[180, 220, 440, 480, 320].map((x, i) => (
          <circle key={x} cx={x} cy={50 + i * 8} r="2" fill="currentColor" opacity="0.5" />
        ))}
        <text x="40" y="370" fill="currentColor" fontSize="11" opacity="0.55" fontFamily="IBM Plex Mono, monospace">ROBOTICS DEMO</text>
      </svg>
    </div>
  );
}
